module.exports = __webpack_public_path__ + "media/images/img_ttl-advance-71bf68d8f89bff38856c3b9dbe58ddd8.png";